import { useMemo } from "react";
import useTrees from "../../../../../Hooks/useTrees";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../Hooks/useWorker";
import { useWorkerGroup } from "../../../../../Hooks/useWorkerGroup";
import { c365devicesListDataId } from "../../../../Reports/Actions/getc365List";
import Button from "../../../../UI/GeneralPurpose/Button";
import { devicePickerId } from "../../../../UI/Specialized/DevicePicker";
import { rootsDataId, tunnelTokenId } from "../Actions/getMachineStatus";
import postGreylists, { postGreylistsId } from "../Actions/postGreylists";
import { passFieldId } from "./Blocked/PassField";

const UIText = {
  "es-CL": { label: "Guardar" },
  "en-US": { label: "Save" },
};

const Submit = ({ user }) => {
  const { auth, dispatch, UI, warehouse, settings } = useUIBp();
  const { working: w2, done, errors } = useWorkerGroup("root");
  const { working } = useWorker(postGreylistsId);
  const trees = useTrees();
  const roots = warehouse[rootsDataId];
  const tunnelToken = UI[tunnelTokenId];
  const { value: password } = UI[passFieldId] ?? {};
  const c365devices = useMemo(
    () => warehouse[c365devicesListDataId] ?? {},
    [warehouse]
  );
  const devicePicker = UI[devicePickerId] ?? { mid: "" };
  const { mid } = devicePicker;

  // const is365device = !!c365devices[user];
  const isTruly365device = c365devices[user] === mid;

  const onClick = () => {
    dispatch(
      postGreylists({
        server: auth.server,
        M365server: auth.M365server,
        tunnelToken,
        password,
        roots,
        trees,
        locale: settings.locale,
        is365device:isTruly365device,
      })
    );
  };

  const disabled = w2 || !done || errors.length > 0;

  return (
    <Button {...{ disabled, working, UIText, onClick, variant: "contained" }} />
  );
};

export default Submit;
